export function buttonsLabel() {
    $('.button').each(function () {
        const buttonText = $(this).find('> span span').text();
        $(this).find('> span').attr('data-label', buttonText);
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/buttonsLabel.js